import { 
  ReactElement, 
  useState, 
  useCallback,
  CSSProperties, 
  useEffect, 
  useRef } from 'react';
import TabTitle, { iProps as TabTitleProps } from '../tab-title/TabTitle';
import './Tabs.css';

interface iProps {
  groupLabel?: string;
  groupLabelPosition?: 'left' | 'right' | 'top';
  groupLabelClass?: string | undefined;
  selectedIndex: number;
  children: ReactElement<TabTitleProps>[];
  onChange?: (tab: TabTitleProps) => void;
}

export default function Tabs(props: iProps) {
  const { children, selectedIndex } = props;
  const [tabUnderLineWidth, setTabUnderlineWidth] = useState(0);
  const [tabUnderlineLeft, setTabUnderlineLeft] = useState(0);

  const tabsRef = useRef<HTMLButtonElement[]>([]);

  const selectedTabHandler = (tab: TabTitleProps ) => {
    if (props.onChange) { 
      props.onChange(tab) 
    }
  };

  const setTabPosition = useCallback(() => {
      const currentTab = tabsRef.current[selectedIndex];
      setTabUnderlineLeft(currentTab?.offsetLeft - 0.5 ?? 0);
      setTabUnderlineWidth(currentTab?.offsetWidth ?? 0);
    },[selectedIndex])
  
  useEffect(() => {
    setTabPosition();
    window.addEventListener("resize", setTabPosition);

    return () => window.removeEventListener("resize", setTabPosition);
  }, [selectedIndex, setTabPosition]);

  let groupLabelPosition: CSSProperties = {};
  let tabFlexDirection: CSSProperties = {
    display: 'flex',
  };

  let position = props.groupLabelPosition;

  if (position && position === 'left') {
    tabFlexDirection = {
      ...tabFlexDirection,
      flexDirection: 'row'
    };
    groupLabelPosition = {
      marginRight: 'auto',
      alignSelf: 'center'
    };
  } else if (position && position === 'right') {
    tabFlexDirection = {
      ...tabFlexDirection,
      flexDirection: 'row-reverse'
    };
    groupLabelPosition = { marginLeft: 'auto' };
  } else if (position && position === 'top') {
    tabFlexDirection = {
      ...tabFlexDirection,
      flexDirection: 'column'
    };
    groupLabelPosition = {
      paddingBottom: '8px'
    }
  } else {
    tabFlexDirection = {
      ...tabFlexDirection,
      justifyContent: 'flex-start'
    };
  }

  return (
    <>
      <div className='tab-header' style={tabFlexDirection}>
        {props.groupLabel &&
          <h4
            className={props.groupLabelClass ? props.groupLabelClass : ''}
            style={groupLabelPosition}
          >
            {props.groupLabel}
          </h4>
        }
        <div className='flex-row tab-group'>
          {children.map((item, index) => (
            <TabTitle
              ref={(el: HTMLButtonElement) => tabsRef.current[index] = el}
              key={item.props.title}
              title={item.props.title}
              index={index}
              isActive={index === selectedIndex}
              setSelectedTab={selectedTabHandler}
            />
          ))}
          <span 
            role='presentation'
            className='slider' 
            style={
              { 
                left: tabUnderlineLeft,
                width: tabUnderLineWidth
              }
            } 
          ></span>
        </div>
      </div>
      {children[selectedIndex]}
    </>
  )
}
